<template>
  <div>
    <v-card :loading="loading">
      <v-card-title flat>
        {{ $tc('common.specification', 2) }}

        <v-spacer></v-spacer>

        <v-menu
          v-model="createMenu"
          :close-on-content-click="false"
          min-width="500"
          transition="slide-y-transition"
        >
          <template #activator="{ attrs, on }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              :loading="creating"
              icon
              color="primary"
            >
              <v-icon> mdi-plus </v-icon>
            </v-btn>
          </template>

          <v-card>
            <v-card-title>
              {{ $t('specificationComponent.createDialogTitle') }}
            </v-card-title>
            <v-card-text>
              <v-form
                ref="newSpecForm"
                v-model="valid"
                @submit.prevent
                lazy-validation
              >
                <v-text-field
                  v-model="newSpecTitle"
                  :label="$t('common.title')"
                  :rules="[ v => !!v || $t('common.requiredField') ]"
                  autofocus
                  outlined
                  @keydown.enter="create"
                />

                <v-switch
                  v-for="feature in features"
                  :key="feature.value"
                  v-model="selectedFeatures"
                  :label="feature.label"
                  :value="feature.value"
                  :disabled="feature.required || (feature.value.includes('Materials') && selectedFeatures.some(x => x.includes('Materials')) && !selectedFeatures.includes(feature.value))"
                  hide-details
                />
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn @click="create">
                {{ $t('common.create') }}
                <v-icon right> mdi-creation </v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
      </v-card-title>

      <v-card-text>
        <v-list>
          <v-list-item
            v-for="spec in specs"
            :key="spec.id"
            :to="`specification/${spec.id}`"
            append
          >
            <v-list-item-content>
              <v-list-item-title>
                {{ spec.title }}
              </v-list-item-title>

              <v-list-item-subtitle>
                {{ spec.groups.length }} {{ $t('common.group') }}
              </v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-icon v-if="!!spec.lockedOn">
              <div class="d-flex align-center">
                <div class="mr-1 text-caption grey--text"> {{ spec.lockedOn | formatDate }} </div>
                <v-icon> mdi-lock-outline </v-icon>
              </div>
            </v-list-item-icon>
          </v-list-item>

          <div
            v-if="!specs.length"
            class="secondary--text"
          >
            {{ $t('specificationComponent.empty') }}
          </div>
        </v-list>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'SpecificationComponent',
  data() {
    return {
      createMenu: false,
      creating: false,
      loading: false,
      newSpecTitle: '',
      specs: [],
      selectedFeatures: [],
      valid: false
    }
  },
  computed: {
    ...mapState({
      features: state => state.specification.features
    })
  },
  methods: {
    async fetchData() {
      const { id } = this.$route.params;

      try {
        this.loading = true;

        const response = await this.$api.get(`specification/relation/${id}`);

        if (!response.data.success) throw response.data.message ?? 'Error getting specifications';

        this.specs = response.data.model;
        this.$emit('loaded', this.specs.map(spec => spec.id));
      } catch (error) {
        this.$notifier.showError({});
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    async create() {
      if (!this.$refs.newSpecForm.validate()) {
        return;
      }

      const spec = {
        title: this.newSpecTitle,
        relationId: this.$route.params.id,
        relationType: 'CustomerDelivery',
        features: this.selectedFeatures
      };

      try {
        this.creating = true;
        
        const response = await this.$api.post('specification', spec);

        // this.$router.push(`specification/${response.data.model}`);
        this.fetchData();
        this.selectedFeatures = []
        this.newSpecTitle = ''
      } catch (error) {
        console.error(error);
        this.$notifier.showError({});
      } finally {
        this.createMenu = false;
        this.creating = false;
      }
    }
  },
  mounted() {
    this.fetchData();

    // Add any required features to selected features
    this.selectedFeatures.push(...this.features.filter(x => x.required).map(x => x.value))
  }
}
</script>
